import React from "react";
import { number } from "prop-types";

const VideosLogo = ({ width = 106, height = 70 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`0 0 ${+width + 50} 80`}>
    <path d="M0 0h203v104H0z" fill="rgba(255,255,255,0)" />
    <g>
      <path
        d="M58.374 84.492L53 78.691c-7.068-7.734-14.325-15.445-21.417-23.25A4.051 4.051 0 0 0 28.286 54c-4.312 0-8.647-.141-12.959-.4a17.119 17.119 0 0 1-8.553-2.617A14.6 14.6 0 0 1 .6 41.553a30.276 30.276 0 0 1-.589-7.215v-6.6c0-3.867.141-7.711.283-11.578a32.375 32.375 0 0 1 1.038-8.09A10.323 10.323 0 0 1 9.979.359 29.594 29.594 0 0 1 17.59.147q5.278.4 10.508 1.132A122.432 122.432 0 0 1 40.4 3.4a14.306 14.306 0 0 1 10.508 9.432 59.27 59.27 0 0 1 2.356 9.432c1.128 5.519 2.141 11.036 3.136 16.507a18.619 18.619 0 0 1 0 7.263 8.439 8.439 0 0 1-6.173 6.555l-.966.259c-.825.189-.825.189-.589.943l9.589 30.347v.377z"
        fill="#febf0f"
        transform="translate(10.009 10.004)"
      />
    </g>
    <path d="M16 10v20.007L34.361 20z" fill="#292929" transform="translate(12.922 18.535)" />
  </svg>
);

VideosLogo.propTypes = {
  width: number,
  height: number,
};

export default VideosLogo;
